// extracted by mini-css-extract-plugin
export default {"menubarContainer":"menubarContainer_TTFm6","leftSection":"leftSection_GoXP5","menuTrigger":"menuTrigger_ja5Yl"};